import { useGetSeavantageAuthQuery } from "@/src/store/apis/seavantage";
import colorSet from "@/src/styles/color";
import { PulseLoader } from "react-spinners";
import NotShareSvg from "@/src/assets/icons/illust-not-share.svg";
import Icon from "../../atom/Icon";
import Typo from "../../atom/Typo";
import { useTranslation } from "react-i18next";

interface CargoTrackingProps {
  blNo: string;
}

const CargoTracking = ({ blNo }: CargoTrackingProps) => {
  const { t } = useTranslation();

  const { isFetching, isError, currentData } = useGetSeavantageAuthQuery(
    undefined,
    {
      refetchOnMountOrArgChange: true,
    }
  );

  if (isFetching) {
    return <PulseLoader color={colorSet.blue4} />;
  }

  if (isError || !currentData) {
    return (
      <>
        <Icon iconSrc={NotShareSvg} iconSize={160} />
        <Typo typoType="b4m">{t("common:shipmentTrackingNoUpdate")}</Typo>
      </>
    );
  }

  return (
    <iframe
      title="cargo-tracking"
      src={`https://svmp.seavantage.com/#/cargo/tracking?authToken=${currentData.row.seaVantageAuthToken}&mblNo=${blNo}&hiddenPanel=info`}
      name="cargoTracking"
      allowFullScreen
      style={{
        height: "700px",
        width: "100%",
      }}
    />
  );
};

export default CargoTracking;
